import { render, staticRenderFns } from "./columns.vue?vue&type=template&id=74b53340&scoped=true"
import script from "./columns.vue?vue&type=script&lang=js"
export * from "./columns.vue?vue&type=script&lang=js"
import style0 from "./columns.vue?vue&type=style&index=0&id=74b53340&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b53340",
  null
  
)

export default component.exports